module.exports = __webpack_public_path__ + "static/media/circleCV.765676b5.mp4";